/* eslint-disable react/no-children-prop */
import { Grid, Typography } from '@material-ui/core';
import { Text } from 'components/styleguide';

export const ongoingImportPrompt = (t) => {
    const content = (
      <div style={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            top: 55,
            width: '550px!',
            maxHeight: '400px',
            overflowY: 'auto',
        }
        }
      >
        <Typography sx={{ fontWeight: 'bold' }} variant="h6" color="textPrimary">
          {t('ongoingImportPrompt.title')}
        </Typography>
        <Grid style={{ marginTop: '15px' }} xs={12}>
          <Text
            variant="formLabel"
            children={t('ongoingImportPrompt.text')}
          />
        </Grid>

      </div>
    );

    return {
        content,
        multiOk: false,
        okLabel: t('ongoingImportPrompt.close'),
        onlyOk: true,
    };
};
